import React from 'react';
import Picture from '../../Picture';
import { SITE_CONSTANTS } from '../../../utils/constants';

import './HeroRatings.scss';

const HeroRatings = ({ hideGoogleMyBusiness = false, showTitle = false, noMargin = false, noWrapper = false }) => {
  const content = (
    <React.Fragment>
      {showTitle && <p className="ia-hero-ratings-title">O Aplicativo mais bem avaliado do mercado:</p>}
      <div className="ia-hero-ratings">
        <div className="ia-rating-card">
          <div className="ia-rating-info">
            <div className="ia-rating-score">
              <span className="ia-rating-value">{SITE_CONSTANTS.GOOGLE_PLAY_RATING}</span>
              <span className="ia-rating-star-char">★</span>
            </div>
            <span className="ia-rating-reviews-text">{SITE_CONSTANTS.GOOGLE_PLAY_REVIEWS}</span>
          </div>
          <Picture className="ia-rating-platform-logo" alt="Google Play Logo" src="/images/site/recursos/google-play.png" />
        </div>
        <div className="ia-rating-card">
          <div className="ia-rating-info">
            <div className="ia-rating-score">
              <span className="ia-rating-value">{SITE_CONSTANTS.APP_STORE_RATING}</span>
              <span className="ia-rating-star-char">★</span>
            </div>
            <span className="ia-rating-reviews-text">{SITE_CONSTANTS.APP_STORE_REVIEWS}</span>
          </div>
          <div className="ia-rating-platform-appstore">
            <Picture className="ia-rating-platform-logo" alt="Apple Logo" src="/images/site/recursos/app-store.png" />
          </div>
        </div>
        {!hideGoogleMyBusiness && (
          <div className="ia-rating-card">
            <div className="ia-rating-info">
              <div className="ia-rating-score">
                <span className="ia-rating-value">{SITE_CONSTANTS.GOOGLE_BUSINESS_RATING}</span>
                <span className="ia-rating-star-char">★</span>
              </div>
              <span className="ia-rating-reviews-text">{SITE_CONSTANTS.GOOGLE_BUSINESS_REVIEWS}</span>
            </div>
            <Picture className="ia-rating-platform-logo" alt="Google Meu Negócio Logo" src="/images/site/recursos/google-meu-negocio.png" />
          </div>
        )}
      </div>
    </React.Fragment>
  );

  if (noWrapper) {
    return content;
  }

  return (
    <div className={`ia-hero-ratings-wrapper ${noMargin ? 'no-margin' : ''}`}>
      {content}
    </div>
  );
};

export default HeroRatings;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/HeroRatings/HeroRatings.jsx